import {
    parseMapEGList, filterEgs, parseMapEGKPI,
    handleMapEGLiveData, mergeMapEGKPI, mergeMapEGSensors
} from '../interceptors/map';
import {
    GET_MAP_EG_LIST, CLEAR_MAP_DATA, FILTER_MAP_EG_LIST, CLEAR_MAP_FILTERS,
    REFRESH_MAP_DATA, ADD_MAP_EG_KPI_BOX_REQUEST, ADD_MAP_EG_KPI_BOX,
    REMOVE_MAP_EG_KPI_BOX, MAP_EG_CUSTOM_KPI, LIVE_MESSAGE, MAP_EG_REQUESTING,
    GET_MAP_EG_SENSORS, MAP_LOADED, MAP_UNLOAD, MAP_POSITION, UPDATE_REPLAY_BOX,
    UPDATE_WORK_WINDOW, REPLAY_PARAMS, MAP_AUTO_ZOOM
} from '../constants/action-types';

const initialState = {
    isMapLoaded: false,
    isAutoZoom: false,
    isNotFound: false,
    isFetching: false,
    positionById: {},
    refreshCount: 0,
    egList: [],
    filteredEgList: [],
    filters: {
        crewIds: null,
        egIds: null,
        operatorIds: null,
        egCategoryGroups: null,
        applyEgCategory: false
    },
    egKPIBoxList: {},
    nonTruckKPI: {
        isRequesting: false,
        plannedAcres: 0, completedAcres: 0, utilization: 0, speed: 0,
        parked: null, batteryPercent: null, connected: null,
        grainYield: null, grainMoisture: null, ptoRPMSpeed: null,
        fuelLevel: null, highlightColor: null, egState: 0
    },
    truckKPI: {
        isRequesting: true,
        loadWeight: 0, speed: 0, loads: 0, avgRoundTripLoadTime: 0,
        parked: null, batteryPercent: null, connected: null,
        fuelLevel: null, highlightColor: null, egState: 0
    },
    balerKPI: {
        speed: 0, bales: 0, avgBaleTime: 0,
        parked: null, batteryPercent: null, connected: null,
        fuelLevel: null, highlightColor: null, egState: 0
    },
    colors: [
        "#e74c3c", "#f1c40f", "#8e44ad", "#F62459", "#19B5FE", "#41ea38",
        "#CA2C68", "#FF20A5", "#c0392b", "#4fe2d6", "#ff926b", "#5e2c0b",
        "#D35400", "#E08A1E", "#A17917", "#1abc9c", "#2ecc71", "#3498db",
        "#9b59b6", "#34495e"
    ],
    replay: {
        enable: true,
        speed: -1,
        range: 1,
        dateRange: {
            start: null,
            end: null
        },
        time: {
            start: null,
            end: null
        },
        enabledDate: {
            start: null,
            end: null
        },
        isEnablePTO: false,
        isEnableLoad: false,
        isEnableSeed: false,
        isEnableBale: false,
        isEnableSpeedVariation: false
    },
    workWindow: {
        enable: true,
        range: 1,
        dateRange: {
            start: null,
            end: null
        },
        time: {
            start: null,
            end: null
        },
        enabledDate: {
            start: null,
            end: null
        }
    }
}

export default (state = initialState, action) => {
    switch (action.type) {
        case MAP_LOADED:
            state = { ...state, isMapLoaded: true };
            break;
        case MAP_UNLOAD:
            state = { ...state, isMapLoaded: false };
            break;
        case MAP_POSITION: {
            const { farmId, position } = action.payload;
            state = { ...state, positionById: { ...state.positionById, [farmId]: position } };
            break;
        }
        case MAP_AUTO_ZOOM:
            state = { ...state, isAutoZoom: action.payload };
            break;
        case MAP_EG_REQUESTING:
            state = { ...state, isFetching: true };
            break;
        case GET_MAP_EG_LIST: {
            const egList = action.payload ? parseMapEGList(action.payload, state.colors) : initialState.egList;
            const filteredEgList = filterEgs(egList, state.filters);
            state = { ...state, egList, filteredEgList, isFetching: false, isNotFound: (filteredEgList.length === 0) };
            break;
        }
        case FILTER_MAP_EG_LIST: {
            const paramsFilters = action.filters || {};
            const filters = { ...initialState.filters, ...paramsFilters };
            if (state.isFetching) state = { ...state, filters };
            else {
                const filteredEgList = filterEgs(state.egList, filters);
                state = { ...state, filters, filteredEgList, isNotFound: (filteredEgList.length === 0) };
            }
            break;
        }
        case CLEAR_MAP_FILTERS:
            state = { ...state, filters: initialState.filters, filteredEgList: state.egList, isNotFound: (state.egList === 0) };
            break;
        case CLEAR_MAP_DATA:
            state = {
                ...state, ...initialState,
                isMapLoaded: state.isMapLoaded,
                isAutoZoom: state.isAutoZoom,
                positionById: state.positionById,
                ...action.isRetainFilter ? { filters: state.filters } : {}
            };
            break;
        case REFRESH_MAP_DATA:
            state = { ...state, isNotFound: false, refreshCount: state.refreshCount + 1 };
            break;
        case ADD_MAP_EG_KPI_BOX_REQUEST: {
            const { egId, kpiType } = action.params;

            let defaultKPI = state.nonTruckKPI;
            if (kpiType === "truck") defaultKPI = state.truckKPI;
            else if (kpiType === "baler") defaultKPI = state.balerKPI;

            state = {
                ...state, egKPIBoxList: {
                    ...state.egKPIBoxList,
                    [egId]: { ...defaultKPI, isRequesting: true }
                }
            };
            break;
        }
        case ADD_MAP_EG_KPI_BOX: {
            const { egId, crewId, deviceId } = action.params;
            state = {
                ...state, egKPIBoxList: {
                    ...state.egKPIBoxList,
                    [egId]: {
                        ...state.egKPIBoxList[egId],
                        isRequesting: false, deviceId, crewId,
                        ...parseMapEGKPI(action.payload, action.params)
                    }
                }
            };
            break;
        }
        case REMOVE_MAP_EG_KPI_BOX: {
            const egKPIBoxList = state.egKPIBoxList;
            delete egKPIBoxList[action.egId];
            state = { ...state, egKPIBoxList };
            break;
        }
        case LIVE_MESSAGE: {
            const mapKPI = handleMapEGLiveData(state, action);
            if (mapKPI) state = { ...state, ...mapKPI };
            break;
        }
        case MAP_EG_CUSTOM_KPI: {
            const mapKPIBox = mergeMapEGKPI(state, action.payload, action.params);
            if (mapKPIBox) state = { ...state, ...mapKPIBox };
            break;
        }
        case GET_MAP_EG_SENSORS:
            const sensor = mergeMapEGSensors(state, action.payload, action.params);
            if (sensor) state = { ...state, ...sensor };
            break;
        case UPDATE_REPLAY_BOX:
            state = { ...state, replay: { ...state.replay, ...action.payload } };
            break;
        case UPDATE_WORK_WINDOW:
            state = { ...state, workWindow: { ...state.workWindow, ...action.payload } };
            break;
        case REPLAY_PARAMS:
            state = {
                ...state,
                replay: { ...state.replay, ...action.payload },
                workWindow: { ...state.workWindow, ...action.payload }
            };
            break;
        default:
            break;
    }

    return state;
}
